namespace SP {
    export interface StockPlacementInfo {
        hall: StockHall;
        section: StockSection;
        unit: StockUnit;
        placement: StockPlacement;
        stock: StockInfo;
        name: string;
        data: string;
        toteId: number;
    }
}